export default __webpack_public_path__ + "static/media/msg-ann.a9eebe7d.svg";